/* eslint-disable import/prefer-default-export */
import { asyncActionType } from 'util/methods';

export const SharedTypes = {
  // CREATE
  UPLOAD_FILE: asyncActionType('UPLOAD_FILE'),
  UPLOAD_MULTIPLE_FILE: asyncActionType('UPLOAD_MULTIPLE_FILE'),
};
